import * as React from 'react';

import { cn } from '@/utils/styles';

interface TableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  isDisabled?: boolean;
}

const TableRow = React.forwardRef<HTMLTableRowElement, TableRowProps>(({ className, isDisabled, ...props }, ref) => (
  <tr
    ref={ref}
    className={cn('border-b border-b-grey-200', { 'bg-grey-50 [&_*]:!text-grey-400': isDisabled }, className)}
    {...props}
  />
));

TableRow.displayName = 'TableRow';

export { TableRow };
